//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentDisplayItem } from './StudentDisplayItem';

export class StudentPortalCancelEventDetails extends ItemBase {
    DeadlineHours: number = 0;
    DeadlinePassed: boolean = false;
    PolicyText: string | null = null;
    Students: StudentDisplayItem[] = [];

    constructor(initializer?: Partial<StudentPortalCancelEventDetails>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentPortalCancelEventDetails";
}
